import React, { useEffect, useState } from 'react'

import { Modal , Box } from "@mui/material"
import { PayPalScriptProvider, PayPalButtons } from "@paypal/react-paypal-js";

import {AiFillCloseCircle} from "react-icons/ai"

import CFormat from "currency-formatter"

import example from '../../../Assets/engine.png'

import { useSelector, useDispatch } from 'react-redux'
import { addItem, removeItem, deleteItem } from '../../../GlobalStore/actions/cartActions'

import './Checkout.scss'





const paymentStyle = {
    position: 'absolute',
    top: '1%',
    left: '2%',
    bottom: "1%",
    right: "2%",
    bgcolor: 'transparent',
    border: 'none',
    overFlowY: "scroll",
    p: 1,
};

const Checkout = () => {
    let dispute = useDispatch()

    const [open, setOpen] = React.useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    let CartData = useSelector((state) => state.CartData)

    const [enteredData, setEnteredData] = useState({
        totalPrice: 0
    })


    const calculateData = async () => {
        let price = 0
        let process = CartData.map((data) => {
            console.log(data);
            price += (data.price * data.qty)
        })
        await Promise.all(process)
        setEnteredData((preVal) => {
            return {
                ...preVal,
                totalPrice: price
            }
        })
    }

    useEffect(() => {
        window.scrollTo(0, 0);
        if (CartData) {
            calculateData()
        }
    }, [CartData])

    return (
        <>
            <div className="check_content">
                <div className='main_checkout'>
                    <div className="check_cont">
                        {
                            CartData.map((data) => {
                                return (
                                    <>
                                        <div className="main_left">
                                            <div className="item">
                                                <div className="example">
                                                    <img src={data.img} />
                                                </div>
                                                <div className="text">
                                                    <div className="name">
                                                        {data.name}
                                                    </div>
                                                    <button onClick={() => dispute(deleteItem(data))}>Remove</button>
                                                </div>
                                            </div>
                                            <div className="label">
                                                Quantity :
                                                <div className="incre">
                                                    <div className="plus" onClick={() => dispute(addItem(data))}>
                                                        +
                                                    </div>
                                                    <div className="one">
                                                        {data.qty}
                                                    </div>
                                                    <div className="minus" onClick={() => dispute(removeItem(data))}>
                                                        -
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="price">
                                                <label>Price :</label>
                                                <div className="num">
                                                    {CFormat.format(data.price, { code: "USD" })}
                                                </div>
                                            </div>
                                        </div>

                                    </>
                                )
                            })
                        }
                    </div>

                    <div className="summary_content">
                        <div className="summary">
                            <span>Summary</span>
                            <div className="types">
                                <div className="total">
                                    Total Items :
                                </div>
                                <div className="num">
                                    {CartData?.length}
                                </div>
                            </div>
                            <div className="types">
                                <div className="total">
                                    Order Total :
                                </div>
                                <div className="num">
                                    <b>{CFormat.format(enteredData.totalPrice, { code: "USD" })}</b>
                                </div>
                            </div>
                            <button onClick={handleOpen}>Checkout</button>
                        </div>
                    </div>
                </div>
            </div>

            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box className="modal_container" sx={paymentStyle}>
                    <div className="close_icon" onClick={handleClose}>
                        <AiFillCloseCircle />
                    </div>
                    <div className="paypal_container">
                        <PayPalScriptProvider textAlign='center'>
                            <PayPalButtons
                                options={{
                                    "client-id": "paypal url should be here",
                                    components: "buttons",
                                    currency: "USD"
                                }}
                                style={{ "layout": "vertical" }}
                                disabled={false}
                                forceReRender={["77", "USD", { "layout": "vertical" }]}
                                fundingSource={undefined}
                                createOrder={(data, actions) => {
                                    return actions.order
                                        .create({
                                            purchase_units: [
                                                {
                                                    amount: {
                                                        currency_code: "USD",
                                                        value: "65",
                                                    },
                                                },
                                            ],
                                        })
                                        .then((orderId) => {
                                            // Your code here after create the order
                                            return orderId;
                                        });
                                }}
                                onApprove={function (data, actions) {
                                    return actions.order.capture().then(function () {
                                        // PaymentSuccess()

                                        alert("Success")
                                    });
                                }}
                                onCancel={() => {
                                    alert("Cancle")
                                    // canclePayment()
                                }}
                            />
                        </PayPalScriptProvider>
                    </div>
                </Box>
            </Modal>
        </>
    )
}

export default Checkout